var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgActivity = function SvgActivity(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.6 70.27V84.1a4.95 4.95 0 0 0 3.02 4.59c1.84.77 3.95.34 5.35-1.08L117 64.34 93.97 41.07A4.87 4.87 0 0 0 88.62 40a4.96 4.96 0 0 0-3.03 4.6v13.8H26.7V36.93c.02-4.36-2.5-6.9-6.85-6.93-4.36.03-6.87 2.57-6.85 6.93v55.14c-.02 4.36 2.5 6.9 6.85 6.93 4.36-.03 6.87-2.57 6.85-6.93v-21.8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgActivity);
export default ForwardRef;